import { BuyProductResDtoInPublic } from '@modusign/openapi-client-subscription/model';

import { requestApi } from '@app/api';
import { withSubscription } from '@app/api/paths';

export function buyProduct(params: {
  productId: string;
  quantity: number;
  workspaceId: string;
}): Promise<BuyProductResDtoInPublic> {
  return requestApi<BuyProductResDtoInPublic>({
    url: withSubscription(
      `/workspaces/${params.workspaceId}/subscription/products/${params.productId}/buy`
    ),
    method: 'POST',
    credentials: true,
    data: {
      quantity: params.quantity,
    },
  }).then(({ data }) => data);
}
